import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchComponent } from '../../../base/search/search.component';
import { HtmlContentSearchResult } from '../../../../models/net/result/html-content-search-result';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { AppService } from '../../../../services/app.service';
import { SessionService } from '../../../../services/session/session.service';
import { HtmlContentSearchRequest } from '../../../../models/net/request/html-content-search-request';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { TextMessageService } from '../../../../services/text-messages/text-message.service';
import { TextMessageSearchResult } from '../../../../models/net/result/text-message-search-result';
import { TextMessageEnvelope } from '../../../../models/net/envelope/text-message-envelope';
import { TextMessageSearchRequest } from '../../../../models/net/request/text-message-search-request';

@Component({
    selector: 'app-text-messages',
    templateUrl: './text-messages.component.html',
    styleUrls: ['./text-messages.component.css', '../../../../app.component.css']
})

export class TextMessagesComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "FromNumber", "ToNumber", "SentOnUTC", "CreatedOnUTC", "Delete"];
    public override searchResult: TextMessageSearchResult[] = [];
    public searchRequestEnvelopes: TextMessageEnvelope[] = [];
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: TextMessageService) {

        super(appService, sessionService, itemService, "textmessage", "TextMessage");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.HtmlContentSearchRequest;
    }

    public override ngOnInit(): void {

        super.ngOnInit();

        this.isSearchMarqueeDisabled = false;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: TextMessageSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var resourceSearchRequest: TextMessageSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (resourceSearchRequest) {

                this.runSearch(resourceSearchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: TextMessageSearchResult) => i.TextMessageId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: TextMessageSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}

